import React from 'react';
import cn from 'classnames';
import styles from './SectionTitle.module.css';

type SectionTitleProps = {
    className?: string;
    children?: React.ReactNode | undefined;
};

const SectionTitle = ({ children, className }: SectionTitleProps) => (
    <p className={cn(styles.sectionTitle, className)}>{children}</p>
);

export default SectionTitle;
